module.exports = __webpack_public_path__ + "static/media/kite_fly.3a33ff94.gif";